// src/App.js
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import LoginPage from "./pages/LoginPage";
import ChildPage from "./pages/ChildPage";
import RegisterChild from "./pages/RegisterChild";
import DeniedPage from "./pages/DeniedPage";
import ProtectedRoute from "./components/auth/ProtectedRoute";
import AccessControl from "./components/auth/AccessControl";
import LoginButtons from "./components/auth/LoginButtons";
/* import ChatWidget from "./components/ChatWidget"; */
import DDropsBanner from "./components/tracker/DDropsBanner";
import { ChildProvider } from "./context/ChildContext";
import SettingsPage from "./pages/SettingsPage";
import SleepOverviewPage from "./pages/SleepOverviewPage";
import PlaygroundPage from "./pages/PlaygroundPage";

const App = () => {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route
            path="/login"
            element={<LoginPage />}
          />
          <Route
            path="/tracker/:childId"
            element={
              <ProtectedRoute>
                <ChildProvider>
                  <AccessControl>
                    <LoginButtons />
                    <DDropsBanner />
                    <ChildPage />
                  </AccessControl>
                </ChildProvider>
              </ProtectedRoute>
            }
          />
          <Route
            path="/register-child"
            element={
              <ChildProvider>
                <LoginButtons />
                <RegisterChild />
              </ChildProvider>
            }
          />
          <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <ChildProvider>
                  <LoginButtons />
                  <SettingsPage />
                </ChildProvider>
              </ProtectedRoute>
            }
          />
          <Route
            path="/sleep-overview"
            element={
              <ProtectedRoute>
                <ChildProvider>
                  <LoginButtons />
                  <SleepOverviewPage />
                </ChildProvider>
              </ProtectedRoute>
            }
          />
          <Route
            path="/playgrounds"
            element={
              <ProtectedRoute>
                <ChildProvider>
                  <LoginButtons />
                  <PlaygroundPage />
                </ChildProvider>
              </ProtectedRoute>
            }
          />
          <Route
            path="/denied"
            element={<DeniedPage />}
          />
          <Route
            path="*"
            element={<LoginPage />}
          />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
};

export default App;
